import { render, staticRenderFns } from "./Novidades.vue?vue&type=template&id=d608c762&scoped=true&"
import script from "./Novidades.vue?vue&type=script&lang=js&"
export * from "./Novidades.vue?vue&type=script&lang=js&"
import style0 from "./Novidades.vue?vue&type=style&index=0&id=d608c762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d608c762",
  null
  
)

export default component.exports